"use client";

import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { useEffect, useRef } from "react";
import { toast } from "sonner";

// Server actions confirm success by redirecting with a `?flash=<message>`
// param (a toast can't survive the redirect otherwise). This reads it, shows
// the toast once, then strips the param from the URL.
export function FlashToaster() {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const shown = useRef<string | null>(null);

  useEffect(() => {
    const flash = searchParams.get("flash");
    if (!flash) {
      shown.current = null;
      return;
    }
    if (shown.current === flash) {
      return;
    } // guard double-fire (StrictMode)
    shown.current = flash;
    toast.success(flash);

    const params = new URLSearchParams(searchParams.toString());
    params.delete("flash");
    const qs = params.toString();
    router.replace(qs ? `${pathname}?${qs}` : pathname, { scroll: false });
  }, [searchParams, pathname, router]);

  return null;
}
